import { mapKeys, camelCase } from 'lodash'
import { baseState, baseMutations, Pagination } from '@/store/mixins'
import OrgChartStructure from '@/api/hr/org-chart-structure'
import dailyAttendance from '@/api/hr/daily-attendance'

export const state = {
  ...baseState,
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_RESOURCES(state, records) {
    const { data, ...meta } = records
    state.resources = data
    state.pagination = new Pagination(mapKeys(meta, (v, k) => camelCase(k)))
  },
}

export const actions = {
  fetch(context, attributes = {}) {
        const params = Object.assign(
      {
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date: '',
        org_chart_structure_id: '',
        status: ''
      },
      attributes
    )

    return dailyAttendance.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response.data)
      return Promise.resolve(response)
    })
  },
  fetchOrgStructures(context) {
    return OrgChartStructure.get({
      params: {
        page: -1,
        fields: {
          hris_org_chart_structure: 'org_chart_structure_id,org_chart_structure'
        }
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
}
